// Feeds the live regions from the open conversation's page (rules: core/liveAnnouncements.ts).
import { useEffect, useRef } from 'react';
import { LiveAnnouncements, type AnnounceState } from '../../core/liveAnnouncements';
import type { PostRecord } from '../../core/records';
import { t, tf } from '../../i18n/i18n';
import { announce } from './LiveRegions';

const SNIPPET = 140;

export function useConversationAnnouncements(channelId: string, posts: readonly PostRecord[] | null, me: string, nameOf: (post: PostRecord) => string): void {
  const state = useRef<AnnounceState | null>(null);
  useEffect(() => {
    if (!posts) return;
    const r = LiveAnnouncements.step(state.current, channelId, posts, me);
    state.current = r.state;
    if (r.arrived.length === 1) {
      const p = r.arrived[0];
      const words = p.message.replace(/\s+/g, ' ').trim();
      announce(tf('web.a11y.newMessage', nameOf(p as PostRecord), words.length > SNIPPET ? `${words.slice(0, SNIPPET)}…` : words), 'polite');
    } else if (r.arrived.length > 1) {
      announce(tf('web.a11y.newMessages', r.arrived.length), 'polite');
    }
    if (r.failedNow > 0) announce(t('web.a11y.sendFailed'), 'assertive');
  }, [posts, channelId, me]);
}
